import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  FileText,
  Award,
  Mail,
  Database,
  LogOut,
} from "lucide-react";
import { useAuth } from "../lib/auth";
import AdminOverview from "../components/admin/AdminOverview";
import AdminUsers from "../components/admin/AdminUsers";
import AdminSubmissions from "../components/admin/AdminSubmissions";
import AdminCertificates from "../components/admin/AdminCertificates";
import AdminWaitlist from "../components/admin/AdminWaitlist";
import AdminContent from "../components/admin/AdminContent";

const TABS = [
  { id: "overview",     label: "Overview",       icon: LayoutDashboard },
  { id: "users",        label: "Users",          icon: Users },
  { id: "submissions",  label: "Submissions",    icon: FileText },
  { id: "certificates", label: "Certificates",   icon: Award },
  { id: "waitlist",     label: "Waitlist",       icon: Mail },
  { id: "content",      label: "Content status", icon: Database },
];

export default function Admin() {
  const [tab, setTab] = useState("overview");
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/", { replace: true });
  };

  return (
    <div className="ftg-admin" data-testid="admin-page">
      <aside className="ftg-admin__sidebar" data-testid="admin-sidebar">
        <Link to="/admin" className="ftg-admin__brand" data-testid="admin-brand">
          <span className="ftg-admin__brand-mark" />
          <span>
            <strong>FutureTec</strong>
            <span className="ftg-admin__brand-sub">Admin</span>
          </span>
        </Link>
        <nav className="ftg-admin__nav">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => setTab(t.id)}
                className={`ftg-admin__nav-item${tab === t.id ? " is-active" : ""}`}
                data-testid={`admin-tab-${t.id}`}
              >
                <Icon size={16} /> <span>{t.label}</span>
              </button>
            );
          })}
        </nav>
        <div className="ftg-admin__sidebar-foot">
          <div className="ftg-admin__me">
            <div className="ftg-admin__me-label">Signed in as</div>
            <div className="ftg-admin__me-email" data-testid="admin-me-email">
              {user?.email || "\u2014"}
            </div>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="ftg-admin__logout"
            data-testid="admin-logout"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>

      <main className="ftg-admin__main">
        <header className="ftg-admin__header">
          <h1 className="ftg-admin__title" data-testid="admin-page-title">
            {TABS.find((t) => t.id === tab)?.label}
          </h1>
          <Link to="/dashboard" className="ftg-admin__leave" data-testid="admin-leave">
            Back to parent view &rarr;
          </Link>
        </header>
        <div className="ftg-admin__content" data-testid={`admin-content-${tab}`}>
          {tab === "overview"     && <AdminOverview />}
          {tab === "users"        && <AdminUsers />}
          {tab === "submissions"  && <AdminSubmissions />}
          {tab === "certificates" && <AdminCertificates />}
          {tab === "waitlist"     && <AdminWaitlist />}
          {tab === "content"      && <AdminContent />}
        </div>
      </main>
    </div>
  );
}
